import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";

const deleteItem = async (id: number | string) => {
    const response = await axios.delete(`/api/item/${id}`);
    return response.data;
};

export default function useDeleteItem() {
    const queryClient = useQueryClient();

    return useMutation((id: number | string) => deleteItem(id), {
        onSuccess: () => {
            queryClient.invalidateQueries(["item"]);
        },
    });
}
